import type { AttachKind, SortKey } from './types';

export interface AttachColumnSpec { key: SortKey; label: string }
export interface AttachLifecycleOption { value: string; label: string }
export interface KindConfig {
  kind: AttachKind;
  title: string;
  searchPlaceholder: string;
  tableColumns: AttachColumnSpec[];
  defaultSort: { columnKey: SortKey; direction: 'asc' | 'desc' };
  lifecycleOptions: AttachLifecycleOption[];
  hasTypeFacet: boolean;
  hasOwnerFacet: boolean;
}
const TITLE: AttachColumnSpec = { key: 'title', label: 'Title' };
const TYPE: AttachColumnSpec = { key: 'type', label: 'Type' };
const OWNER: AttachColumnSpec = { key: 'owner', label: 'Owner' };
const UPDATED: AttachColumnSpec = { key: 'updated', label: 'Updated' };
export const KIND_CONFIG: Record<AttachKind, KindConfig> = {
  documents: { kind: 'documents', title: 'Attach documents', searchPlaceholder: 'Search documents…',
    tableColumns: [TITLE, TYPE, OWNER, UPDATED], defaultSort: { columnKey: 'updated', direction: 'desc' },
    lifecycleOptions: [{ value: 'draft', label: 'Draft' }, { value: 'published', label: 'Published' }, { value: 'archived', label: 'Archived' }],
    hasTypeFacet: true, hasOwnerFacet: true },
  epics: { kind: 'epics', title: 'Attach epics', searchPlaceholder: 'Search epics…',
    tableColumns: [TITLE, OWNER, UPDATED], defaultSort: { columnKey: 'updated', direction: 'desc' },
    lifecycleOptions: [], hasTypeFacet: false, hasOwnerFacet: true },
  'work-items': { kind: 'work-items', title: 'Attach work items', searchPlaceholder: 'Search work items…',
    tableColumns: [TITLE, TYPE, OWNER, UPDATED], defaultSort: { columnKey: 'updated', direction: 'desc' },
    lifecycleOptions: [], hasTypeFacet: true, hasOwnerFacet: true },
};
